module.exports = __webpack_public_path__ + "bc07c1cf91d6c7817c867ee2ae08b72f.svg";